export default __webpack_public_path__ + "images/assets/e8122b5fefeee352c6680c0453970a1e.svg";